import React from "react";
import HighChart from "./HighChart";
import dayjs from "dayjs";
import Skeleton from "react-loading-skeleton";

interface ReportData {
  [date: string]: {
    start_verification_requests?: number;
    verification_requests?: number;
    start_verification_receipts?: number;
    verification_receipts?: number;
  };
}

interface CustomerChartProps {
  customer: {
    reports: ReportData;
  };
}

const CustomerStats: React.FC<CustomerChartProps> = (props) => {
  const reportData: ReportData = props?.customer?.reports;
  const categories = reportData && Object.keys(reportData);
  const today = dayjs().format("YYYY/MM/DD");

  const initialValues = {
    startVerificationRequests: [] as number[],
    verificationRequests: [] as number[],
    startVerificationReceipts: [] as number[],
    verificationReceipts: [] as number[],
    formattedDates: [] as string[],
  };

  const result = categories?.length > 0 
    ? categories?.reduce(
        (verificationStatus, date) => {
          verificationStatus.startVerificationRequests.push(
            reportData[date]?.start_verification_requests || 0
          );
          verificationStatus.verificationRequests.push(
            reportData[date]?.verification_requests || 0
          );
          verificationStatus.startVerificationReceipts.push(
            reportData[date]?.start_verification_receipts || 0
          );
          verificationStatus.verificationReceipts.push(
            reportData[date]?.verification_receipts || 0
          );
          verificationStatus.formattedDates.push(
            dayjs(date).format("YYYY/MM/DD") === today
              ? "Today"
              : dayjs(date).format("DD/MM")
          );
          return verificationStatus;
        },
        { ...initialValues }
      )
    : initialValues;

  const {
    startVerificationRequests,
    verificationRequests,
    startVerificationReceipts,
    verificationReceipts,
    formattedDates,
  } = result;

  const customerChartOptions = {
    chart: {
      type: "column",
      width: 650,
      scrollablePlotArea: {
        minWidth: categories?.length * 100,
        scrollPositionX: 0,
        scrollPositionY: 0,
      },
      height: 350,
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: formattedDates,
      title: {
        text: "",
      },
      lineColor: "rgba(164, 165, 181, 0.2)",
    },
    yAxis: {
      title: {
        text: "",
      },
      gridLineDashStyle: "Dash",
      gridLineColor: "rgba(164, 165, 181, 0.2)",
      gridLineWidth: 1,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      shared: true,
    },
    legend: {
      enabled: categories?.length > 0 && reportData ? true : false,
      layout: "horizontal",
      align: "left",
      verticalAlign: "top",
      floating: false,
      y: -15
    },
    series: [
      {
        name: "Started Verification",
        data: startVerificationRequests,
        color: "#9930DC",
      },
      {
        name: "Verifications",
        data: verificationRequests,
        color: "#4983ED",
      },
      {
        name: "Started Receipts",
        data: startVerificationReceipts,
        color: "#00BFFF",
      },
      {
        name: "Receipts",
        data: verificationReceipts,
        color: "#1E90FF",
      },
    ],
  };

  return props?.customer ? (
    <HighChart options={customerChartOptions} />
  ) : (
    <Skeleton count={14} />
  );
};

export default CustomerStats;
